import PerfectScrollbar from '../vendor/perfect-scrollbar';

const initScrollbar = () => {
  const projects = document.querySelectorAll('.scrollbar');
  if (projects.length <= 0) {
    return;
  }

  projects.forEach((project) => {
    const ps = new PerfectScrollbar(project, {
      wheelPropagation: true,
    });
    ps.update();
  });
};

export {initScrollbar};
